import React from 'react'
import { Header } from './Header'

interface PageLayoutProps {
  children: React.ReactNode
  showHeader?: boolean
  className?: string
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  showHeader = true,
  className = '',
}) => {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark flex flex-col">
      {showHeader && <Header />}
      <div className={`flex flex-1 ${showHeader ? 'pt-24' : ''} h-screen overflow-hidden`}>
        <main
          className={`flex-1 overflow-y-auto transition-all duration-300 ${className}`}
        >
          {children}
        </main>
      </div>
    </div>
  )
}

